import React, { Component } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { CellDataTypes } from '@cluster/web-components'
import { RootState } from '../store/reducers/persistedReducer';
import { doCloseChannelBlur } from '../store/actions/channelLayout';
import Cell from '../Cell/Cell';
import CSS from 'csstype';
import { selectCellLayoutIds, selectLayoutColumnDims } from '../store/selectors';

import classnames from 'classnames'
import styles from './Channel.module.scss'
import { LAYOUT_COLUMN_GAP, LAYOUT_OUTER_SPACING } from './ChannelDataTypes';

class ChannelGrid extends Component<PropsFromRedux> {

  render() {
    let cells = [];
    let style: CSS.Properties = {
      rowGap: CellDataTypes.CELL_GAP + "px",
      columnGap: CellDataTypes.CELL_GAP + "px",
      gridRowGap: CellDataTypes.CELL_GAP + "px",
      gridColumnGap: CellDataTypes.CELL_GAP + "px",
      padding: LAYOUT_OUTER_SPACING + "px"
    };

    let columnDividers = [];

    // Loop through the cell data
    // We pass to a generic cell wrapper and let the wrapper determine which type of cell it is.
    for (let i=0; i<this.props.cellIds.length; i++) {
      const cell = <Cell id={this.props.cellIds[i]} key={i} />;
      cells.push(cell);
    }

    // Sets the channel grid up.
    style = {
      ...style,
      width: this.props.channelWidth + "px",
      height: this.props.channelHeight + "px",
    }

    // Calculate columns grid
    if (this.props.layoutType === 'columns') {
      let msGridColumns = "", gridTemplateColumns = "";

      // Loop through columns
      let columnDividerStart = 0;
      for(let i=0; i<this.props.columnDims.length; i++) {
        msGridColumns += "(" + CellDataTypes.CELL_HEIGHT + "px)[" + this.props.columnDims[i].gridWidth + "] "
        gridTemplateColumns += 'repeat(' + this.props.columnDims[i].gridWidth + ', ' + CellDataTypes.CELL_WIDTH + 'px) '

        if (i !== this.props.columnDims.length-1) {
          msGridColumns += LAYOUT_COLUMN_GAP+'px ';
          gridTemplateColumns += LAYOUT_COLUMN_GAP+'px ';

          // Generate layout dividers
          columnDividerStart += this.props.columnDims[i].gridWidth+1;
          const columnDividerHeight = Math.max(this.props.columnDims[i].gridHeight, this.props.columnDims[i+1].gridHeight);
          columnDividers.push(<div className={styles.columnDivider} key={"divider" + i} style={{
            msGridColumn: columnDividerStart,
            msGridColumnSpan: 1,
            gridColumn: columnDividerStart + " / span 1",
            msGridRow: 1,
            msGridRowSpan: columnDividerHeight,
            gridRow: 1 + " / span " + columnDividerHeight,
          }}></div>);
        }
      }

      style = {
        ...style,
        msGridColumns,
        msGridRows: "(" + CellDataTypes.CELL_HEIGHT + "px)[" + this.props.gridHeight + "]",
        gridTemplateColumns,
        gridTemplateRows: 'repeat(' + this.props.gridHeight + ', ' + CellDataTypes.CELL_HEIGHT + 'px)',
      };
    }
    // Calculate normal grid
    else {
      style = {
        ...style,
        msGridColumns: "(" + CellDataTypes.CELL_WIDTH + "px)[" + this.props.gridSize + "]",
        msGridRows: "(" + CellDataTypes.CELL_HEIGHT + "px)[" + this.props.gridSize + "]",
        gridTemplateColumns: 'repeat(' + this.props.gridSize + ', ' + CellDataTypes.CELL_WIDTH + 'px)',
        gridTemplateRows: 'repeat(' + this.props.gridSize + ', ' + CellDataTypes.CELL_HEIGHT + 'px)',
      };
    }
    return (
      <div className={styles.channelGrid} style={style}>
        {cells}
        { columnDividers }
        <ChannelBlur active={this.props.showBlur} closeHandler={(e) => this.props.doCloseChannelBlur()} />
      </div>
    );
  }
}

type ChannelBlurProps = {
  active: boolean
  closeHandler: (e: React.MouseEvent | React.TouchEvent) => void
}

// The blur component to show when a cell is in focus.
function ChannelBlur({active, closeHandler}: ChannelBlurProps) {

  return <div className={classnames(styles.channelBlur, {[styles.channelBlur_open]: active})} onClick={closeHandler} onTouchEnd={closeHandler} />
}

const mapState = (state: RootState) => {
  return {
    layoutType: state.channelLayout.data.layoutConfig?.type??'grid',
    gridSize: state.channelLayout.data.size,
    gridHeight: state.channelLayout.data.layoutConfig?.height,
    columnDims: selectLayoutColumnDims(state)??[],
    cellIds: selectCellLayoutIds(state),
    channelHeight: state.channelLayout.data.channelHeight,
    channelWidth: state.channelLayout.data.channelWidth,
    showBlur: state.channelLayout.focusedCell !== false || state.channelLayout.channelPopup !== "none",
  }
}

const mapDispatch = {
  doCloseChannelBlur,
}

const connector = connect(
  mapState,
  mapDispatch
)

type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(ChannelGrid);
